import { useNavigate, useParams, useLocation, Params } from "react-router-dom";
import React, { ComponentType, JSX } from "react";

export function withRouting<TProps, TParams extends IParams = {}>(component: ComponentType<TProps & IRouterProps<TParams>>): React.FC<TProps>
{
    return function (props: TProps): JSX.Element
    {
        const navigate = useNavigate();
        const params = useParams<TParams>();
        const location = useLocation();
        const Component = component;

        return (
            <Component
                {...props}
                navigate={navigate}
                params={params}
                location={location}
            />
        );
    }
}

export interface IRouterProps<TParams extends IParams = {}>
{
    navigate: ReturnType<typeof useNavigate>;
    params: Readonly<[TParams] extends [string] ? Params<TParams> : Partial<TParams>>;
    location: ReturnType<typeof useLocation>;
}

export type IParams = { [key: string]: string | undefined } | {};
